import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { DataTableComponent } from './data-table.component';
import { DataTableColumnTmplComponent } from './tmpl/data-table-column-tmpl.component';
import { DataTableCellViewTmplComponent } from './tmpl/data-table-cell-view-tmpl.component';
import { DataTableCellEditTmplComponent } from './tmpl/data-table-cell-edit-tmpl.component';
import { DataTableCellComponent } from './data-table-cell.component';
import { DataTableBodyComponent } from './data-table-body.component';
import { DataTableHeadComponent } from './data-table-head.component';
import { DataTableRowComponent } from './data-table-row.component';
import { DataTableHeadTmplComponent } from './tmpl/data-table-head-tmpl.component';
import { DataTableFootTmplComponent } from './tmpl/data-table-foot-tmpl.component';
import { DataTableFootComponent } from './data-table-foot.component';
import { PaginationModule } from '@duoduo-oba/ng-devui/pagination';
import { DataTablePagerComponent } from './data-table-pager.component';
import { DataTablePagerTmplComponent } from './tmpl/data-table-pager-tmpl.component';
import { DataTableHeadCellTmplComponent } from './tmpl/data-table-head-cell-tmpl.component';
import { DCommonModule } from '@duoduo-oba/ng-devui/common';
import { DatepickerModule } from '@duoduo-oba/ng-devui/datepicker';
import { CheckBoxModule } from '@duoduo-oba/ng-devui/checkbox';
import { ResizeableDirective } from './resizeable.directive';
import { ButtonModule } from '@duoduo-oba/ng-devui/button';
import { SelectModule, SelectComponent } from '@duoduo-oba/ng-devui/select';
import { InputNumberModule, InputNumberComponent } from '@duoduo-oba/ng-devui/input-number';
import { DropDownModule } from '@duoduo-oba/ng-devui/dropdown';
import { TreeSelectModule, TreeSelectComponent } from '@duoduo-oba/ng-devui/tree-select';
import { SafePipeModule } from '@duoduo-oba/ng-devui/utils';
import { DisPlayCellValuePipe } from './display-cell-value.pipe';
import { TooltipModule } from '@duoduo-oba/ng-devui/tooltip';
import { EditorDirective } from './editor-host.directive';
import { DataTableCellTmplComponent } from './tmpl/data-table-cell-tmpl.component';
import { DragDropModule } from '@duoduo-oba/ng-devui/dragdrop';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ScrollingModule,
    PaginationModule,
    DCommonModule,
    DatepickerModule,
    SelectModule,
    CheckBoxModule,
    ButtonModule,
    InputNumberModule,
    DropDownModule,
    TreeSelectModule,
    SafePipeModule,
    TooltipModule,
    DragDropModule
  ],
  exports: [
    DataTableComponent,
    DataTableColumnTmplComponent,
    DataTableCellViewTmplComponent,
    DataTableCellEditTmplComponent,
    DataTableBodyComponent,
    DataTableHeadComponent,
    DataTableCellComponent,
    DataTableHeadTmplComponent,
    DataTableFootTmplComponent,
    DataTableFootComponent,
    DataTableCellTmplComponent,
    DataTablePagerComponent,
    DataTablePagerTmplComponent,
    DataTableRowComponent,
    DataTableHeadCellTmplComponent
  ],
  declarations: [
    DataTableComponent,
    DataTableColumnTmplComponent,
    DataTableCellViewTmplComponent,
    DataTableCellEditTmplComponent,
    DataTableBodyComponent,
    DataTableHeadComponent,
    DataTableCellComponent,
    DataTableHeadTmplComponent,
    DataTableFootTmplComponent,
    DataTableFootComponent,
    DataTableCellTmplComponent,
    DataTablePagerComponent,
    DataTablePagerTmplComponent,
    DataTableRowComponent,
    ResizeableDirective,
    DataTableHeadCellTmplComponent,
    DisPlayCellValuePipe,
    EditorDirective
  ],
  entryComponents: [
    InputNumberComponent,
    SelectComponent,
    TreeSelectComponent
  ],
  providers: [],
})
export class DataTableModule {
}
